import {upload} from "@/services/utils";

export const uploadImageMixin = {
  methods: {
    async uploadImage(file) {
      const {data: {data: {path}}} = await upload({ file });
      return path;
    },
  }
}
